import React, { useEffect } from "react";
import AppScreen from "./AppScreen";

const TermsSection = () => {
  useEffect(() => {
    document.documentElement.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <AppScreen>
      <section className="w-11/12 sm:w-8/12 p-4 my-24 mx-auto bg-white rounded-lg">
        <h1 className="text-center text-xl sm:text-3xl font-semibold mt-10">
          Terms of usage:
        </h1>
        <p className="px-8 pb-8 whitespace-pre-wrap leading-loose  text-gray-700">
          <h2 className="font-semibold text-xl md:text-2xl text-gray-800 my-7">
            Usage acceptance clause
          </h2>
          By accessing and using this website “Zofium.com”, (“We”, “Us”, “The
          Company”), you (The User) accepts and agrees to be bound by the terms
          and conditions as mentioned in this agreement. The user is also
          subject to any rules as posted on the website presently or in the
          future and understands that these rules are subject to change without
          prior notice based on the company’s discretion.
          <div className="text-center text-sm mt-4">
            ANY PARTICIPATION IN THIS SITE WILL STAND AS ACCEPTANCE OF THIS
            AGREEMENT. IF YOU DO NOT AGREE TO THE ABOVE, PLEASE DO NOT USE THIS
            SITE.
          </div>
          <h2 className="font-semibold text-xl md:text-2xl text-gray-800 my-7">
            1. Accuracy of information
          </h2>
          This site and its components are offered for informational purposes
          only; the company shall not be responsible or liable for the accuracy,
          usefulness or availability of any information transmitted or made
          available via the site, and shall not be responsible or liable to any
          error or omissions in that information.
          <h2 className="font-semibold text-xl md:text-2xl text-gray-800 my-7">
            2. External Links
          </h2>
          This site contains links to other websites and content belonging to or
          originating from third parties or links to websites in banners or
          other advertising. Such external links are not investigated,
          monitored, or checked for accuracy, adequacy, validity, reliability,
          availability, or completeness by us. WE DO NOT WARRANT, ENDORSE,
          GUARANTEE, OR ASSUME RESPONSIBILITY FOR THE ACCURACY OR RELIABILITY OF
          ANY INFORMATION OFFERED BY THIRD-PARTY WEBSITES LINKED THROUGH THE
          SITE OR ANY WEBSITE OR FEATURE LINKED IN ANY BANNER OR OTHER
          ADVERTISING. WE WILL NOT BE A PARTY TO OR IN ANY WAY BE RESPONSIBLE
          FOR MONITORING ANY TRANSACTION BETWEEN YOU AND THIRD-PARTY PROVIDERS
          OF PRODUCTS OR SERVICES.
          <h2 className="font-semibold text-xl md:text-2xl text-gray-800 my-7">
            3. Feedback and suggestions
          </h2>
          Any feedback and suggestions provided to the company may or may not be
          implemented based on the discretion of the company. If user provided
          suggestions/feedbacks are used, the user will NOT BE COMPENSATED in
          any form, monetary or otherwise. 3. Privacy and data The searches
          performed by the user may be used to train AI models and/or be
          provided to their party vendors for data processing and/or search
          optimization purposes.
          <h2 className="font-semibold text-xl md:text-2xl text-gray-800 my-7">
            4. Advertisements
          </h2>
          All advertisements posted on the website are through affiliation and
          the company is compensated for user interaction with the
          advertisements as agreed upon by the company and the advertiser.
        </p>
      </section>
    </AppScreen>
  );
};

export default TermsSection;
